import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ReplenishmentTaskPageRBAC = {
  pageID: 'a555f6b38edb6e90dfb0eb3329a6ff08',
  elementID: {
    BtnCancelReplenish: 'f956c1f6a7b568a497aeea8ba48937ac',
    BtnPrintSlipTask: '961b91e97c9f37337192c52ce8f38eb8',
    BtnPartialReplenishment: '2ab154f76712f9cc1ebc617bf253da3f',
    TableList: 'b75bcafa69f0d5e1d1e458322b98ba5c',
    BtnAssignIC: '4f96f8c35eb1740fa219c41d352dc4db',
    BtnStartReplenish: '14d66dc13c7cb5e6b9a63f6de317aae2',
    BtnFinishReplenish: '1bcc639bf6c1474fe848984c4a630f41',
  },
} as const

export const useRBACReplenishmentTaskPage = createUseRBAC(ReplenishmentTaskPageRBAC.elementID)

export type UseRBACReplenishmentTaskPageType = ReturnType<typeof useRBACReplenishmentTaskPage>
